import { initReactI18next } from 'react-i18next';
import { getDefaultLocale } from '@/utils/locale';
import { setItem } from '@analytics/localstorage-utils';
import i18n from 'i18next';
import Backend from 'i18next-http-backend';

i18n
  .use({
    type: 'languageDetector',
    detect: () => getDefaultLocale(),
  })
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: false,
    load: 'currentOnly',
    debug: false,
    interpolation: { escapeValue: true },
    backend: {
      loadPath:
        import.meta.env.MODE !== 'dev'
          ? location.origin + import.meta.env.VITE_PUBLIC_PATH + 'i18n/{{lng}}.json'
          : '/i18n/{{lng}}.json',
    },
  });

i18n.on('languageChanged', (lng) => {
  const html = document.querySelector('html');
  setItem('i18Lng', JSON.stringify(lng));
  html?.setAttribute('lang', lng);
  html?.setAttribute('dir', i18n.dir(lng));
});
